import React from 'react'; 
 
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from './store';
 
import './index.css'
import Header from 'component/mobile_header' 
import ExperImg from './components/experImg'
import ExperTab from './components/experTab'
import ExperDes from './components/experDes'
class LabRoomExper extends React.Component{
    constructor(props){
    super(props);
    this.state={
      courseid:'',
      sid:'',
      title:''
    }
  }

  componentWillMount(){

    // document.title = '实验课';
    const {getSubjectInfo,getMySubRecord,user_id} = this.props;
    let str = this.props.match.params.id
    let newJson = this.getJson(str)
    if(newJson[0]&&newJson[0].courseid&&newJson[0].sid ){
      let courseid = newJson[0].courseid;
      let sid = newJson[0].sid;
      this.setState({
         courseid,
         sid
      })
      getSubjectInfo(courseid,sid)
      getMySubRecord(user_id,sid)
      if(this.props.title){
          this.setState({
            title:this.props.title,  
          })
       }else{
          window.history.go(-1)
       }
    }else{
      window.history.go(-1)
    }

   
  }
  evil(fn) {
     var Fn = Function; //一个变量指向Function，防止有些前端编译工具报错
     return new Fn('return ' + fn)();
  }
  getJson(str){
    let newstr = str.replace(/=/g,":");
    let arr=newstr.split('&'); 
    let stringObj= "[{" +arr + "}]";
     let  jsonobj={}
      try {
        //在这里运行代码
           jsonobj = this.evil(stringObj) 
        }
      catch(err) {
        //在这里处理错误
          jsonobj ={}
        }
     
    return jsonobj
  }   
  render(){ 
    const {info,lab,end_at,starttime,score} = this.props;  
    const {title}=this.state
    return (
      <div> 
        <Header title = { title}/>
        <div className="container labinfo">
          <ExperImg  thumb={lab.get('thumb')?lab.get('thumb'):''}/>
          <ExperDes  data={info}/>
          <ExperTab  data={info} endtime={end_at} starttime={starttime} score={score}/>
        </div>  
      </div>
      
      )
  }
}
 
 
const mapState = (state) => ({
  info: state.getIn(['courseexperinfo', 'subjectInfo']),
  lab: state.getIn(['courseexperinfo', 'lab']), 
  end_at: state.getIn(['courseexperinfo', 'subjectInfo','end_at']),
  starttime: state.getIn(['courseexperinfo', 'subjectInfo','start_at']),
  score: state.getIn(['courseexperinfo', 'score']), 
  user_id: state.getIn(['home','userinfo', 'user_id']),
  title: state.getIn(['courseexper', 'info','title']), 
   
})
 
const mapDispatch = (dispatch) => ({
  getSubjectInfo(course_id,sub_id){
    dispatch(actionCreators.getSubjectInfo(course_id,sub_id))
  },
  getMySubRecord(user_id, sub_id){
    dispatch(actionCreators.getMySubRecord(user_id, sub_id))
  } 
})

 

export default connect(mapState, mapDispatch)(LabRoomExper);
